import { Component, OnInit, ViewChild, inject, signal } from '@angular/core'
import { SmartquoteNavComponent } from '../components/smartquote-nav/smartquote-nav.component'
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts'
import { SmartQuoteService } from 'src/app/core/services/smartquote/smartquote.service'
import { ChartOptions } from 'src/app/shared/types/chart-options'
import { Observable, tap } from 'rxjs'
import { StatContainer } from 'src/app/shared/interfaces/statistics/stat-container.interface'
import { StatCounter } from 'src/app/shared/interfaces/statistics/stat-counter.interface'
import { AsyncPipe } from '@angular/common'
import { Utils } from 'src/app/shared/utilties'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { AxisChartSeries } from 'src/app/shared/shared/charts/AxisChartSeries.interface'
import { CardHeaderDirective } from 'src/app/shared/directives/card/card-header.directive'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { SimpleStatBoxComponent } from 'src/app/shared/components/statistics/simple-stat-box/simple-stat-box.component'
import { SmartQuoteStatistics } from 'src/app/shared/interfaces/smartquote/smartquote-statistics.interface'

@Component({
    selector: 'sf-smartquote-statistics',
    imports: [
        NgApexchartsModule,
        NgbDropdownModule,
        CardComponent,
        CardHeaderDirective,
        SimpleStatBoxComponent,
        ButtonComponent,
        SmartquoteNavComponent,
        AsyncPipe,
    ],
    templateUrl: './smartquote-statistics.component.html',
    styleUrl: './smartquote-statistics.component.scss',
})
export class SmartquoteStatisticsComponent implements OnInit {
    private smartQuoteService = inject(SmartQuoteService)

    @ViewChild('chart') chart!: ChartComponent
    public chartOptions!: Partial<ChartOptions>

    yearOptions: number[] = []

    year = new Date().getFullYear()
    selectedYear = signal(this.year)

    base = signal<test[]>([])
    statistics2$!: Observable<SmartQuoteStatistics>
    cachedStatistics!: StatContainer<StatCounter>[]

    constructor() {
        this.chartOptions = {
            series: [
                {
                    name: 'series',
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                },
            ],
            chart: {
                height: 350,
                type: 'bar',
                fontFamily: 'Roboto, sans-serif',
                toolbar: {
                    show: false,
                },
            },
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            },
        }
    }

    ngOnInit(): void {
        this.statistics2$ = this.smartQuoteService.getStatistics().pipe(
            tap((result) => {
                const statContainers = result.totals
                this.cachedStatistics = statContainers

                this.yearOptions = statContainers
                    .flatMap((stat) => stat.data.map((y) => y.year))
                    .reduce((acc: number[], stat: number) => {
                        if (acc.includes(stat)) {
                            return acc
                        }
                        return [...acc, stat]
                    }, [])
                    .sort()
                    .reverse()

                this.loadChart()
                this.loadStats()
            })
        )
    }

    onChangeYear(year: number): void {
        this.selectedYear.update(() => year)
        this.loadChart()
        this.loadStats()
    }

    loadStats() {
        const t = this.cachedStatistics.reduce((acc: test[], curr: StatContainer<StatCounter>) => {
            const total = curr.data
                .filter((x) => this.selectedYear() === -1 || x.year === this.selectedYear())
                .reduce((a, c) => a + c.count, 0)

            acc.push({ name: curr.name, year: this.selectedYear(), count: total })

            return acc
        }, [])

        this.base.update(() => t)
    }

    loadChart(): void {
        this.chartOptions.series = this.cachedStatistics.reduce(
            (accumulator: AxisChartSeries[], currentValue: StatContainer<StatCounter>) => {
                const { name, data } = currentValue

                accumulator.push({
                    name: this.selectedYear() === -1 ? `${name} (All Time)` : `${name} (${this.selectedYear()})`,
                    color: currentValue.colour,
                    data:
                        this.selectedYear() === -1
                            ? data.reduce((acc: { x: string; y: number }[], curr) => {
                                  if (acc.find((x) => x.x === Utils.getMonthName(curr.month))) {
                                      acc.find((x) => x.x === Utils.getMonthName(curr.month))!.y += curr.count
                                      return acc
                                  }

                                  acc.push({ x: Utils.getMonthName(curr.month), y: curr.count })
                                  return acc
                              }, [])
                            : data
                                  .filter((x) => x.year === this.selectedYear())
                                  .map((d) => {
                                      return { x: `${Utils.getMonthName(d.month)} ${this.selectedYear()}`, y: d.count }
                                  }),
                })

                return accumulator
            },
            []
        )
    }
}

interface test {
    name: string
    year: number
    count: number
}
